export const CHART_COLORS = [
  {
    // Orange
    default: '#FF630F',
    hover: '#FF823F',
  },
  {
    // Blue
    default: '#306EE8',
    hover: '#598BED',
  },
  {
    // Green
    default: '#118834',
    hover: '#41A05D',
  },
  {
    // Black
    default: '#1a1a1a',
    hover: '#333333',
  },
  {
    // Red
    default: '#DD3322',
    hover: '#E45C4E',
  },
  {
    // Purple
    default: '#6A057F',
    hover: '#8B2FA9',
  },
  {
    // Brown
    default: '#A52A2A',
    hover: '#B0463E',
  },
  {
    // Pink
    default: '#FF99AC',
    hover: '#FFADBD',
  },
  {
    // Yellow
    default: '#FFCC33',
    hover: '#FFD65C',
  },
  {
    // Lime
    default: '#00FF00',
    hover: '#33FF33',
  },
  {
    // Aqua
    default: '#00FFFF',
    hover: '#33FFFF',
  },
  {
    // Orange 50%
    default: '#FF630F80',
    hover: '#FF823F66',
  },
  {
    // Blue 50%
    default: '#306EE880',
    hover: '#598BED66',
  },
  {
    // Green 50%
    default: '#11883480',
    hover: '#41A05D66',
  },
  {
    // Black 50%
    default: '#1a1a1a80',
    hover: '#33333366',
  },
  {
    // Red 50%
    default: '#DD332280',
    hover: '#E45C4E66',
  },
  {
    // Purple 50%
    default: '#6A057F80',
    hover: '#8B2FA966',
  },
  {
    // Brown 50%
    default: '#A52A2A80',
    hover: '#B0463E66',
  },
  {
    // Pink 50%
    default: '#FF99AC80',
    hover: '#FFADBD66',
  },
  {
    // Yellow 50%
    default: '#FFCC3380',
    hover: '#FFD65C66',
  },
  {
    // Lime 50%
    default: '#00FF0080',
    hover: '#33FF3366',
  },
  {
    // Aqua 50%
    default: '#00FFFF80',
    hover: '#33FFFF66',
  },
];

export const CHART_UNKNOWN_COLOR = {
  default: 'rgba(26,26,26,0.16)',
  hover: 'rgba(26,26,26,0.08)',
};

export const CHART_REFERENCE_COLOR = 'rgba(26,26,26,0.16)';
